export default Object.freeze({
  PAGE_TIT: '게시판 관리',
  TABLE_TIT: '게시판 설정',
  ADD_BTN: '게시판 추가',
  REMOVE_BTN: '삭제',
  ARCODION_LST_EMPTY: '게시판을 생성 해 주세요.',
  ARCODION_ITEM_EMPTY: '좌측에서 게시판을 추가 하시면, 상세설정이 가능합니다.',
  ARCODION_H: '게시판 상세설정',
  BOARD_NO: '게시판 번호',
  BOARD_ID: '게시판 ID',
  BOARD_NAME: '게시판명',
  BOARD_DESCRIPTION: '게시판 설명',
  BOARD_NAME_PLACEHOLDER: '게시판명 입력',
  BOARD_DESCRIPTION_PLACEHOLDER: '게시판 설명 입력',
  BOARD_ID_DESCRIPTION_PLACEHOLDER: '게시판 ID 입력',
  USEARTICLEIMAGE: '게시글 대표이미지 사용',
  USABLE: '게시판 사용여부',
  USE_CATEGORY: '카테고리 사용',
  MEMBER_WRITE: '회원 글쓰기',
  GUEST_WRITE: '비회원 글쓰기',
  SECRET: '비밀 글쓰기',
  REPLY: '답글',
  ARCODION_TITLE: '게시판 카테고리',
  CATEGORY_TR: '카테고리 번호',
  CATEGORY_TITLE_TH: '카테고리 ',
  REMOVE_CATEGORY_BTN: '삭제',
  ADD_CATEGORY: '+카테고리 추가',
  SAVE_BTN: '변경사항 저장',
  CATEGORY_NAME_PLACEHOLDER: '카테고리명 입력',
  DETAIL_USED: '사용함',
  DETAIL_UNUSED: '사용 안 함',
  DETAIL_NEW_GRADE_NAME: '게시판명 입력',

  WARN_BOARD_MOVE_ARTICLES: '기존 카테고리에 등록 된 게시글은 자동으로 이동되지 않습니다. 게시글은 게시글 관리 메뉴에서 수정하시기 바랍니다.',
  ERR_NOT_FOUND_BOARD: '선택된 게시판이 없습니다.',
  ERR_BOARD_NAME_NULL: '게시판명이 지정되지 않았습니다',
  ERR_DELETE_BOARD_WITH_CUSTOMER: '게시글 등록이 있어 게시판을 삭제할 수 없습니다.',
  ERR_BOARD_CATEGORY_NAME_NULL: '게시판의 카테고리가 지정되지 않았습니다.',
  CANCEL_DELETE_CATEGORY: '게시글이 등록되어 있어 카테고리를 삭제할 수 없습니다.',
  CONFIRM_DELETE_CATEGORY: '게시판 카테고리를 삭제하시겠습니까?',
  COMFIRM_BEFORE_MODIFY: '변경된 내용을 저장하시겠습니까?',
  COMFIRM_BEFORE_DELETE_BOARD: '게시판을 삭제하시겠습니까?',
  COMPLETE_SAVE: '변경사항이 저장 되었습니다.',
});
